import React from 'react';
import Loading from './Loading';

const LoadingPage = () => {
  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Loading />
    </div>
  );
};

export default LoadingPage;
